import { type Settings as PortalFrameworkSettings } from "@sal/portal";
import { RoutePermissionSetting } from "@sal/onevent-portal";

type LayoutSettings = {
	Orientation?: "Vertical" | "Horizontal";
};

type DropboxDirectorySettings = {
	Read: string | readonly string[];
	Write: string;
};

type AppSettings = {
	Layout?: LayoutSettings;
	PortalFramework: PortalFrameworkSettings;
	DropboxDirectories?: DropboxDirectorySettings;
};

const AppSettings: AppSettings = {
	Layout: {
		Orientation: "Vertical"
	},
	PortalFramework: {
		logoUrl: "/images/logo.png",
		loginTitle: "Log into your account",
		defaultColorMode: "system"
	},
	DropboxDirectories: {
		Read: ["/Apps/DocumentLink for iCOS LIVE", "/Apps/DocumentLink for iCOS LIVE/Bookings"],
		Write: "/Apps/DocumentLink for iCOS LIVE/Bookings"
	}
} as const;

export default AppSettings;

export const routePermissionMapping: { [key: string]: RoutePermissionSetting } = {
	dashboard: {
		path: "/Dashboard",
		securityContext: "portal_Menu",
		securityContextPermission: "Web_Consignment_Dashboard"
	},
	freightBooking: {
		path: "/FreightBooking",
		securityContext: "apI_FreightConsignment",
		securityContextPermission: "Write"
	},
	containerBooking: {
		path: "/ContainerBooking",
		securityContext: "apI_ContainerConsignment",
		securityContextPermission: "Write"
	},
	freightDetail: {
		path: "/Freight/:id",
		securityContext: "apI_FreightConsignment",
		securityContextPermission: "Read"
	},
	containerDetail: {
		path: "/Container/:id",
		securityContext: "apI_ContainerConsignment",
		securityContextPermission: "Read"
	},
	track: {
		path: "/Track",
		securityContext: "portal_Menu",
		securityContextPermission: "Web_TrackSearch"
	},
	rates: {
		path: "/Rates",
		securityContext: "portal_Menu",
		securityContextPermission: "Web_RatesPage"
	},
	consignmentList: {
		path: "/ConsignmentList",
		securityContext: "portal_Menu",
		securityContextPermission: "Web_Consignment_List"
	},
	networkHealth: {
		path: "/NetworkHealth",
		securityContext: "portal_Menu",
		securityContextPermission: "Web_Network_Health"
	},
	users: {
		path: "/Users",
		securityContext: "portal_Users",
		securityContextPermission: "Read"
	},
	analytics: {
		path: "/Analytics",
		securityContext: "portal_Menu",
		securityContextPermission: "Web_Analytics"
	},
	customers: {
		path: "/Customers",
		securityContext: "portal_Menu",
		securityContextPermission: "Web_Customer"
	},
	locations: {
		path: "/Locations",
		securityContext: "portal_Menu",
		securityContextPermission: "Web_Locations"
	},
	containerTransportDashboard: {
		path: "/ContainerDashboard",
		securityContext: "portal_Menu",
		securityContextPermission: "Web_CT_Dashboard"
	},
	importFCLTransportOrder: {
		path: "/ImportFCLTransportOrder",
		securityContext: "apI_ContainerTransportImportFCLOrder",
		securityContextPermission: "Read"
	},
	exportFCLTransportOrder: {
		path: "/ExportFCLTransportOrder",
		securityContext: "apI_ContainerTransportExportFCLOrder",
		securityContextPermission: "Read"
	},
	importContainer: {
		path: "/ImportContainer",
		securityContext: "apI_ContainerTransportImportContainer",
		securityContextPermission: "Read"
	},
	exportContainer: {
		path: "/ExportContainer",
		securityContext: "apI_ContainerTransportExportContainer",
		securityContextPermission: "Read"
	},
	order: {
		path: "/Order",
		permissions: [
			["apI_ContainerTransportImportFCLOrder", "Write"],
			["apI_ContainerTransportExportFCLOrder", "Write"],
			["apI_ContainerTransportGeneralFreightOrder", "Write"]
		]
	}
};

export const placesRequestOptions = {
	autocompleteRequestOptions: {
		componentRestrictions: { country: "nz" }
	},
	placeDetailsRequestOptions: {
		fields: ["address_components", "formatted_address", "name", "place_id", "geometry"],
		region: "nz"
	}
};
